import { CHCappMedicareNtmCampaignModal } from './medicare-ntm-campaign-modal.component.js';
export { CHCappMedicareNtmCampaignModal };

customElements.define('chcapp-medicare-ntm-campaign-modal', CHCappMedicareNtmCampaignModal);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-medicare-ntm-campaign-modal': CHCappMedicareNtmCampaignModal;
  }
}
